import { SenecDialogContent } from "src/components/modal/senec-dialog/SenecDialogContent";
import { ReactElement } from "react";
import { StyledDialog } from "src/components/modal/senec-dialog/SenecDialog.styled";

export interface SenecDialogProps {
    "data-testid"?: string;
    title: string;
    isOpen: boolean;
    onClose: () => void;
    MainComponent: ReactElement;
    BottomComponent?: ReactElement;
    icon?: ReactElement;
    showDivider?: boolean;
    closeOnBackdropClick?: boolean;
    showLoader?: boolean;
}

/**
 * The `SenecDialog` is a dialog component. It has a title, can be opened or closed, and contains primary and secondary actions representable with respective text.
 * @param title header title
 * @param isOpen show dialog
 * @param onClose a callback function that gets called when the component is closed.
 * @param MainComponent a ReactElement which is displayed in the center
 * @param BottomComponent a ReactElement which is displayed at the bottom
 * @param icon an icon to be displayed in the dialog header
 * @param dataTestId id to find component in render tests
 * @param showDivider show divider
 * @param closeOnBackdropClick should close dialog on click onto the backdrop
 * @param showLoader renders `SenecLoadingOverlay` above `MainComponent`
 * @constructor
 */
export const SenecDialog = ({
    title,
    isOpen,
    onClose,
    MainComponent,
    BottomComponent,
    icon,
    "data-testid": dataTestId = "senec-dialog",
    showDivider = true,
    closeOnBackdropClick = false,
    showLoader = false,
}: SenecDialogProps) => {
    const onDialogClose = () => {
        if (closeOnBackdropClick) {
            onClose();
        }
    };

    return (
        <StyledDialog open={isOpen} onClose={onDialogClose} maxWidth={false}>
            <SenecDialogContent
                data-testid={dataTestId}
                title={title}
                icon={icon}
                MainComponent={MainComponent}
                BottomComponent={BottomComponent}
                onClose={onClose}
                showDivider={showDivider}
                showLoader={showLoader}
            />
        </StyledDialog>
    );
};
